// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leave-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  font-family: inherit;
}
.leave-dialog__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 0;
}
.leave-dialog__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fff8e1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.leave-dialog__icon mat-icon {
  color: #f59e0b;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.leave-dialog__close {
  color: #9ca3af;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.leave-dialog__close:hover {
  background: #f3f4f6;
  color: #374151;
}
.leave-dialog__body {
  padding: 20px 24px 24px;
}
.leave-dialog__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
}
.leave-dialog__message {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
}
.leave-dialog__actions {
  display: flex;
  gap: 12px;
  padding: 0 24px 24px;
  justify-content: flex-end;
}
.leave-dialog__btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.15s;
  line-height: 1;
}
.leave-dialog__btn--stay {
  background: #f3f4f6;
  color: #374151;
}
.leave-dialog__btn--stay:hover {
  background: #e5e7eb;
}
.leave-dialog__btn--leave {
  background: #ef4444;
  color: #fff;
}
.leave-dialog__btn--leave:hover {
  background: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/leave-confirmation-dialog/leave-confirmation-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,oBAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAAN;AAIE;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAFJ;AAII;EACE,mBAAA;EACA,cAAA;AAFN;AAME;EACE,uBAAA;AAJJ;AAOE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AALJ;AAQE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AANJ;AASE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,yBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;AARJ;AAUI;EACE,mBAAA;EACA,cAAA;AARN;AAUM;EACE,mBAAA;AARR;AAYI;EACE,mBAAA;EACA,WAAA;AAVN;AAYM;EACE,mBAAA;AAVR","sourcesContent":[".leave-dialog {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  font-family: inherit;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 24px 24px 0;\n  }\n\n  &__icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #fff8e1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    mat-icon {\n      color: #f59e0b;\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  &__close {\n    color: #9ca3af;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f3f4f6;\n      color: #374151;\n    }\n  }\n\n  &__body {\n    padding: 20px 24px 24px;\n  }\n\n  &__title {\n    margin: 0 0 8px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #111827;\n    line-height: 1.4;\n  }\n\n  &__message {\n    margin: 0;\n    font-size: 14px;\n    color: #6b7280;\n    line-height: 1.6;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    padding: 0 24px 24px;\n    justify-content: flex-end;\n  }\n\n  &__btn {\n    padding: 10px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    border: none;\n    transition: all 0.15s;\n    line-height: 1;\n\n    &--stay {\n      background: #f3f4f6;\n      color: #374151;\n\n      &:hover {\n        background: #e5e7eb;\n      }\n    }\n\n    &--leave {\n      background: #ef4444;\n      color: #fff;\n\n      &:hover {\n        background: #dc2626;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
